<div #topBarContainer class="top-bar-message" [class.wide]="isProductRequest"
  [pTooltip]="userMessage"
  tooltipPosition="left">
  <span #messageContainer>
    <strong>{{ userMessage }}</strong>&nbsp;{{ message }}
  </span>
</div>